<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-table
          striped
          hover
          small
          :items="itemComputed"
          :fields="fields"
          :foot-clone="Object.entries(priceByDate).length > 0"
          style="overflow: auto;"
          :sort-by.sync="sortByComputed"
          :sort-desc.sync="sortDescComputed"
          :tbody-tr-class="'text-right'"
          :class="{'fixed-table': fields.length >= 20}"
        >
          <template
            slot="no"
            slot-scope="data"
          >
            <div class="text-right">
              {{ $numeral(data.item.no).format('0,0[.]00') }}
            </div>
          </template>
          <template
            slot="hospital_name"
            slot-scope="data"
          >
            <div
              class="text-left"
              style="text-align: left; "
            >
              {{ data.item.hospital_name }}
            </div>
          </template>
          <template
            v-for="(price, index) in priceByDate"
            :slot="`${index}`"
            slot-scope="data"
          >
            <div
              :key="index"
              class="text-right"
            >
              {{ $numeral(data.item[index]).format('0,0[.]00') }}
            </div> 
          </template>
          <template
            slot="test"
            slot-scope="data"
          >
            <div
              class="text-left"
              style="text-align: left; "
            >
              {{ data.item.test }}
            </div>
          </template>
          <template :slot="`FOOT_no`">
            <div />
          </template>
          <template :slot="`FOOT_hospital_name`">
            <div class="text-right">
              รวม
            </div> 
          </template>
          <template :slot="`FOOT_test`">
            <div class="text-right">
              รวม
            </div> 
          </template>
          <template
            v-for="(price, index) in priceByDate"
            :slot="`FOOT_${index}`"
          >
            <div
              :key="index"
              class="text-right"
            >
              {{ $numeral(price).format('0,0[.]00') }}
            </div> 
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "StatFilterListComponent",
    props: {
      items: {
        required: true
      },
      fields: {
        required: true
      },
      sortBy: {
        required: true
      },
      sortDesc: {
        required: true
      },
      priceByDate: {
        required: true
      }
    },
    data() {
      return {
      }
    },
    computed: {
      itemComputed(){
          return this.items.map((item, index) => Object.assign({ no: index + 1 }, item))
      },
      sortByComputed: {
        get() {
          return this.sortBy
        },
        set(val) {
          this.$emit('update:sortBy', val)
        }
      },
      sortDescComputed: {
        get() {
          return this.sortDesc
        },
        set(val) {
          this.$emit('update:sortDesc', val)
        }
      }
    },
    mounted() {
      // this.sortBy = this.fields[0]['key']
      // console.log(this.sortBy)
    }
  }
</script>

<style>
    .fixed-table {
        display: block;
    }
</style>

<style scoped>

</style>
